import React, { useEffect, useState, useMemo } from "react";
import CustomButton from "../../AppComponent/CustomButton/CustomButton";
import { useDispatch, useSelector } from "react-redux";
import {
  getRoportDatasActions,
  getRoportpostActions,
  setThecountBasedRenders,
  setTheoptions,
  //--filer
  setGeoLoactionStateAction,
  setZoneActions,
  setRegionActions,
  setClientBranchSearchAction,
  settheReportRange2,
  setTheReportRange1,
  getRoportDeletedActions,
} from "../../../Redux/Slice";
import ReactTable from "../../AppComponent/Table";
import correctIcons from "../../../Assets/AppComponent/icons/Group 359.svg";
import Pendingimg from "../../../Assets/AppComponent/icons/Group 145.svg";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import validator from "validator";
import TagsInput from "react-tagsinput";
import "react-tagsinput/react-tagsinput.css";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import ReportCreateSheet from "./ReportCreateSheet";
import { DateRangePicker, Stack } from "rsuite";
import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import addDays from "date-fns/addDays";
import "rsuite/dist/rsuite.css";
import isAfter from "date-fns/isAfter";
import { differenceInDays } from "date-fns";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import _ from "lodash";
import loadergif from "../../../Assets/MainComponent/LoaderGIF.gif";
import downloadoffer from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-20 (1).svg";
import XmarkImageWhite from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-28.svg";
import DeleteImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-05.svg";
import Delete from "../../AppComponent/Popup/Delete";

const ReportSheetExportDatas = () => {
  const dispatch = useDispatch();
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive,
  );

  const UserObjectData = useSelector((state) => state.users.UserData);

  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setsearch] = useState("");
  const state = useSelector((state) => state);
  const [sno, setsno] = useState(0);
  const [emailError, setEmailError] = useState("");
  const [Validattion, setValidation] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [inputValue, setInputValue] = useState("");
  const FileterState = {
    status: "",
  };
  const [selectDisplay, setDisplay] = useState([]);
  const [selectVal, SetSelectval] = useState(FileterState);

  const [show, setshow] = useState(false);
  const [DeleteID, setDeleteId] = useState();
  const [DeletePopup, setDeletePopup] = useState(false);

  const options = [
    { value: "", label: "All" },
    { value: "0", label: "Process" },
    { value: "1", label: "Success" },
    { value: "2", label: "Failed" },
  ];

  // STATUS_ = [("0", "Process"), ("1", "Success"), ("2", "Failed")]

  const [StatusVal, setStatusVal] = useState([{ value: "", label: "ALL" }]);
  const ClearState = (Counts) => {
    if (Counts == 2) {
      SetSelectval({
        ...selectVal,
        status: "",
      });
    }
  };

  var today = new Date();
  var priorDate = new Date(new Date().setDate(today.getDate() - 30));
  var it = convert(state.EmployeeVerificationsNeed.reportrange1);
  var gt = convert(state.EmployeeVerificationsNeed.reportRange2);
  // console.log(it, gt);
  const [range, setrange] = useState(
    state.EmployeeVerificationsNeed.reportrange1 == "" ? [] : [gt, it],
  );

  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  //----Handle----Date=-----Changes---
  const handlechangedate = (value) => {
    console.log(value, "vlues");

    if (value != null) {
      setrange((oldArray) => [...oldArray, value.slice(0, 10)]);
    }
  };

  const HandleSubmits = () => {
    setsearch("");
    setdtPageindex(1);
    if (DeleteID != undefined) {
      const payload = {
        DeleteID: DeleteID,
        reportpayloads: {
          // search: search,
          page: 1,
          page_size: 10,
          // status: selectVal.status,
        },
      };
      dispatch(getRoportDeletedActions(payload, setDeletePopup(false)));
    }
  };
  //--------_____Filter-----------Based---On----Status--
  const count = (Counts, values, sel, SelectedValues) => {
    setDisplay(SelectedValues);
    setdtPageindex(1);
    dispatch(setTheoptions(SelectedValues));
    dispatch(setThecountBasedRenders(2));
    setStatusVal(SelectedValues);
    // console.log(values, "values");
    if (values == "Process") {
      ///Pending
      SetSelectval({
        ...selectVal,
        status: "0",
      });
    } else if (values == "Failed") {
      //Decline
      SetSelectval({
        ...selectVal,
        status: "2",
      });
    } else if (values == "Success") {
      //Approve
      SetSelectval({
        ...selectVal,
        status: "1",
      });
    } else if (values == "All") {
      //Approve
      SetSelectval({
        ...selectVal,
        status: "",
      });
    }
  };
  useEffect(() => {
    if (range.length > 0 && !range.includes("NaN-aN-aN")) {
      dispatch(setTheReportRange1(range[0]));
      dispatch(settheReportRange2(range[1]));
    }
  }, [range]);

  const Navigate = useNavigate();
  // useEffect(() => {
  //   const payload = {
  //     search: search,
  //     page_size: 10,
  //     page: dtpageindex,
  //     status: selectVal.status,

  //   };
  //   dispatch(getRoportDatasActions(payload));
  // }, [dtpageindex, selectVal, range ,search]);

  useEffect(() => {
    if (show == false) {
      const payload = {
        // search: search,
        page_size: 10,
        page: dtpageindex,
        // status: selectVal.status,
      };
      dispatch(getRoportDatasActions(payload));
      const intervalId = setInterval(() => {
        dispatch(getRoportDatasActions(payload));
      }, 15000); // 15 seconds interval

      return () => clearInterval(intervalId);
    }
  }, [dtpageindex, range, show]);

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    //  console.log(arg, "args");
    setdtPageindex(arg);
  };

  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
        // console.log("Searching for:", e);

        setsearch(e);
      }, 500),
    [],
  );

  // -----Search------------------------
  function tochange(e) {
    setdtPageindex(1);
    // setsearch(e);
    debouncedSearch(e);

    // if (e.trim() != undefined && e.trim() != "") {
    //   const payload = {
    //     search: e.trim(),
    //     page_size: dtpagesize,
    //     page: 1,
    //     status: selectVal.status,
    //   };
    //   dispatch(getRoportDatasActions(payload));
    // }
    // if (e == "" || search == "") {
    //   const payload = {
    //     search: "",
    //     page_size: dtpagesize,
    //     page: 1,
    //     status: selectVal.status,
    //   };
    //   dispatch(getRoportDatasActions(payload));
    // }
  }
  const capitalizeFirstLetter = (Letter) => {
    return Letter.charAt(0).toUpperCase() + Letter.slice(1);
  };

  const columns = useMemo(
    () => [
      {
        Header: "S.NO",
        accessor: "",
        Cell: (row) => {
          console.log(row.row);
          console.log(sno);
          return <p>{Number(sno + row.row.index + 1)}</p>;
        },
      },
      {
        Header: "Report Type",
        accessor: "",
        Cell: (row) => {
          const { report_type } = row.row.original;
          console.log(report_type, "report_type");
          return (
            <>
              {row.row.original.report_type &&
                row.row.original.report_type != null ? (
                <span>
                  {report_type == 0
                    ? "USER DESIGNATION"
                    : report_type == 1
                      ? "USER DETAILS"
                      : report_type == 2
                        ? "ONBOARDING SUMMARY"
                        : report_type == 3
                          ? "ONBOARDER DETAILS"
                          : report_type == 4
                            ? "FORM EXPORT"
                            : report_type == 5
                              ? "ATTENDANCE REPORT"
                              : report_type == 6
                                ? "USER COST REPORT"
                                : report_type == 7
                                  ? "ATTENDANCE SUMMARY"
                                  : report_type == 8
                                    ? "ATTENDANCE MONTHLY REPORT"
                                    : report_type == 9
                                      ? "ATTENDANCE MONTHLY SUMMARY"
                                      : report_type == 10
                                        ? "COUNT REPORT"
                                        : report_type == 11
                                          ? "ID CARD REPORT"
                                          : report_type == 12
                                            ? "CASUAL LABOUR REPORT"
                                            : report_type == 13 ||
                                              report_type == "exit_employee_report"
                                              ? "EXIT EMPLOYEE REPORT"
                                              : "---"}
                </span>
              ) : (
                <span>---</span>
              )}
            </>
          );
        },
      },

      {
        Header: "EMAIL",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              {row.row.original.email != undefined &&
                row.row.original.email != null &&
                row.row.original.email != "" ? (
                <span>
                  {row.row.original.email != null &&
                    row.row.original.email.map((item) => {
                      return (
                        <span
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          {item}
                        </span>
                      );
                    })}
                </span>
              ) : (
                <span>---</span>
              )}
            </>
          );
        },
      },

      {
        Header: "Created Date",
        accessor: "",
        Cell: (row) => {
          const dateString = row.row.original.created_at;
          const dateObject = new Date(dateString);
          const hours = dateObject.getHours();
          const minutes = dateObject.getMinutes();
          const seconds = dateObject.getSeconds();
          const amOrPm = hours >= 12 ? "PM" : "AM";
          const twelveHourFormat = hours % 12 || 12;
          const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

          const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;
          return (
            <>
              <span>
                {`${row.row.original.created_at.slice(0, 10) +
                  "  " +
                  formattedTime
                  }`}
              </span>
            </>
          );
        },
      },

      {
        Header: "STATUS",
        accessor: "status",
        Cell: (row) => {
          const originalString = row.row.original.status;
          const capitalizedString = capitalizeFirstLetter(originalString);
          return (
            <>
              {row.row.original.status != undefined ? (
                <>
                  {row.row.original.status.toLowerCase() == "0" ? (
                    <div className="StatusList">
                      <img src={Pendingimg} />
                      <span>{"Process"}</span>
                    </div>
                  ) : (
                    <>
                      {row.row.original.status.toLowerCase() == "2" ? (
                        <div className="StatusList">
                          <div className="DeclineStatus">
                            <span>x</span>
                          </div>
                          <span>{"Failed"}</span>
                        </div>
                      ) : (
                        <>
                          {row.row.original.status.toLowerCase() == "1" ? (
                            <div className="StatusList">
                              <img src={correctIcons} />
                              <span>{"Success"}</span>
                            </div>
                          ) : null}
                        </>
                      )}
                    </>
                  )}
                </>
              ) : (
                <span>---</span>
              )}
            </>
          );
        },
      },

      {
        Header: "DOWNLOAD",
        accessor: "",
        Cell: (row) => {
          const originalString = row.row.original.status;
          const capitalizedString = capitalizeFirstLetter(originalString);
          const [hovered, setHovered] = useState(null);
          console.log(row.row.original.media_url, "asoiud askdh sd");

          return (
            <>
              <>
                {row.row.original.media_url != null &&
                  row.row.original.status.toLowerCase() == "1" ? (
                  <div
                    className="StatusList"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "centercolumns",
                      width: "50%",
                    }}
                  >
                    <span
                      style={{
                        padding: "7px",
                        border: "1px solid  #234492",
                        background: "#234492",
                        color: "#fff",
                        borderRadius: "6px",
                        display: "flex",
                        cursor: "pointer",
                        position: "relative",
                      }}
                      onMouseEnter={() => setHovered("Download")}
                      onMouseLeave={() => setHovered(null)}
                      onClick={(e) => {
                        window.open(row.row.original.media_url);
                      }}
                    >
                      {/* <i
                        class="fa-solid fa-download"
                        style={{ color: "#fff" }}
                      ></i> */}
                      {/* Download */}

                      <span className="AllformExcel">
                        <img src={downloadoffer} />
                        {hovered === "Download" && (
                          <div className="custom-tooltip">Download</div>
                        )}
                      </span>
                    </span>
                  </div>
                ) : (
                  <>
                    {row.row.original.status.toLowerCase() == "0" ? (
                      <div
                        className="StatusList"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "50%",
                          position: "relative",
                        }}
                        onMouseEnter={() => setHovered("Process")}
                        onMouseLeave={() => setHovered(null)}
                      >
                        <div style={{ width: "46px", height: "46px" }}>
                          <img
                            src={loadergif}
                            style={{ width: "100%", height: "100%" }}
                          />
                          {hovered === "Process" && (
                            <div className="custom-tooltip">Process</div>
                          )}
                        </div>
                      </div>
                    ) : (
                      <>
                        <div
                          className="StatusList"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "50%",
                            position: "relative",
                          }}
                          onMouseEnter={() => setHovered("Failed")}
                          onMouseLeave={() => setHovered(null)}
                        >
                          <span
                            style={{
                              padding: "7px",
                              border: "1px solid  #234492",
                              background: "#234492",
                              color: "#fff",
                              borderRadius: "6px",
                              display: "flex",
                              cursor: "pointer",
                            }}
                          >
                            <span className="AllformExcel">
                              <img src={XmarkImageWhite} />
                              {hovered === "Failed" && (
                                <div className="custom-tooltip">Failed</div>
                              )}
                            </span>
                          </span>
                        </div>
                      </>
                    )}
                  </>
                )}
              </>
            </>
          );
        },
      },
      {
        Header: "Actions",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <div
                class="actions"
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  gap: "5px",
                }}
              >
                <button
                  type="button"
                  class="btn Status"
                  onClick={(e) => {
                    e.stopPropagation();
                    setsearch("");
                    setDeleteId(row.row.original.id);
                    setDeletePopup(true);
                  }}
                >
                  <span className="OuterActionSpan">
                    <span className="EditImages">
                      <img src={DeleteImages} />
                    </span>

                    <span className="ActionsList"> Delete </span>
                  </span>
                </button>
              </div>
            </>
          );
        },
      },
    ],

    [sno],
  );

  const predefinedBottomRanges = [
    {
      label: "Today",
      value: [new Date(), new Date()],
      placement: "left",
    },
    {
      label: "Yesterday",
      value: [addDays(new Date(), -1), addDays(new Date(), -1)],
      placement: "left",
    },
    {
      label: "This week",
      value: [startOfWeek(new Date()), endOfWeek(new Date())],
      placement: "left",
    },
    {
      label: "Last week",
      value: (value, index) => {
        const [start = new Date()] = value[index] || [];
        return [
          addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
          addDays(endOfWeek(start, { weekStartsOn: 0 }), -7),
        ];
      },
      placement: "left",
    },
    {
      label: "Last 30 days",
      value: [subDays(new Date(), 29), new Date()],
      placement: "left",
    },
  ];

  const handleNext = (next) => {
    setdtPageindex(next + 1);
  };

  const GotoEnteredPage = (gotopage) => {
    setdtPageindex(gotopage);
  };

  const handlePrevious = (previous) => {
    if (previous != 0) {
      setdtPageindex(previous);
    }
  };

  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h3> Report</h3>
            <div className="reprot_listed_cards">
              <div className="card">
                <div className="card-body">
                  <span
                    style={{
                      fontSize: "14px",
                      color: "#6c757d",
                      fontWeight: "500",
                    }}
                  >
                    Showing the latest 10 records
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="Add-User col-sm-5">
            <button
              onClick={(e) => {
                // Navigate("/reportsheetcreate");
                setshow(true);
              }}
              className="ButtonCSS"
            >
              Create
            </button>
          </div>
        </div>
        <br />
        <div
          style={{
            padding: " 0px 40px",
            marginTop: "-13px",
            marginBottom: "20px",
          }}
        >
          <ReactTable
            data={state.ReportSheetData.ReportSheetDATAS}
            columns={columns}
            // totalItems={state.ReportSheetData.Total_Count}
            currentPage={currentPage}
            onChange={tochange}
            setCurrentPage={setCurrentPage}
            pagesize={pagesize}
            dtpagesize={pageSize}
            dtpageindex={dtpageindex}
            pageindex={pageindex}
            // datacount={state.ReportSheetData.Total_Count}
            // datacount={state.ReportSheetData?.Total_Count}
            totalItems={state.ReportSheetData?.Total_Count}
            datacount={10}
            MakeCreate={false}
            ///--- emoloyee role based filters -
            // Filter={true}
            // EmployeeRoleTrue={false}
            // EmployeeRoleOption={EmpRoles}
            // EMpROleSelected={EMpROleSelected}
            // HandleEMprole={HandleEMprole}
            //---status
            onPrevious={handlePrevious}
            onNextpage={handleNext}
            GotoEnteredPage={GotoEnteredPage}
            // value={StatusVal}
            // options={options}
            // count={count}
            // ClearState={ClearState}
            placeHold={"All"}
            setsno={setsno}
            sno={sno}
            id={"spe"}
            ApproveRequestFilter={true}
          />
        </div>
      </div>
      {show ? (
        <ReportCreateSheet
          show={show}
          setshow={setshow}
          search={search}
          status={selectVal.status}
          dtpageindex={dtpageindex}
          fromRange={range}
        />
      ) : null}

      <Tooltip id="list-ToolTips" zIndex="0" />

      {DeletePopup ? (
        <Delete
          show={DeletePopup}
          setShow={setDeletePopup}
          onSubmit={HandleSubmits}
          Content={"Do you want to delete the report"}
        />
      ) : null}
    </>
  );
};

export default ReportSheetExportDatas;
